<div id="mainLoader" class="mainLoader" *ngIf="showLoader">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle == 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle == 'K12 Insight'"></div>
  </div>
</div>

<div
  *ngIf="
    surveyDecode?.IsErrorVisible ||
    surveyDecode?.isCancelAccMsgVisible ||
    surveyDecode?.isCancelBlockedMsgVisible
  "
  class="bg-overlay"
></div>

<div
  *ngIf="
    surveyDecode?.IsErrorVisible ||
    surveyDecode?.isCancelAccMsgVisible ||
    surveyDecode?.isCancelBlockedMsgVisible
  "
  id="dvSurveyMsgWrapper"
  runat="server"
  class="sd-decode SurveyMsgWrapper small-survey-width"
>
  <div class="message-wrapper" [ngClass]="surveyDecode?.stralertModel" style="display: none">
    <ng-container *ngIf="surveyDecode?.isMobile && err != 2; else WebErrTitle">
      <div>
        <div class="message-heading-text">
          <div [innerHTML]="surveyDecode?.ForbiddenTitle | headerFooterHtml"></div>
        </div>
      </div>
      <div class="mobile-message-icon"></div>
      <div class="message-info-wrapper image-width sogo">
        <div class="message-text">
          <div>
            <span
              style="margin: 16px 30px"
              id="spanMobileMsg"
              runat="server"
              [innerHTML]="surveyDecode?.MobileMsg | headerFooterHtml"
            ></span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #WebErrTitle>
      <div
        *ngIf="
          surveyDecode?.IsErrorVisible ||
          surveyDecode?.isCancelAccMsgVisible ||
          surveyDecode?.isCancelBlockedMsgVisible
        "
        class="message-header-wrapper"
      >
        <div class="message-icon browser-message"></div>
        <div class="message-heading-text">
          <div [innerHTML]="surveyDecode?.ForbiddenTitle | headerFooterHtml"></div>
        </div>
      </div>

      <div
        *ngIf="
          surveyDecode?.IsErrorVisible ||
          surveyDecode?.isCancelAccMsgVisible ||
          surveyDecode?.isCancelBlockedMsgVisible
        "
        class="message-info-wrapper image-width sogo"
      >
        <div class="message-text">
          <span
            *ngIf="surveyDecode?.IsErrorVisible"
            id="LBL_Participated"
            style="font-weight: 500; font-size: 20px"
          >
            <div ID="lbl_ErrorText" [innerHTML]="surveyDecode?.ErrorText | headerFooterHtml"></div>
          </span>
          <span
            *ngIf="surveyDecode?.isCancelAccMsgVisible"
            id="spnCancelAccMsg"
            [innerHTML]="surveyDecode?.CancelAccMsg | headerFooterHtml"
            runat="server"
            visible="false"
          >
            <br /><br />
            This survey is no longer active.Please contact
            <a href="{{ surveyDecode?.clienturl }}">{{ clienturl }}</a> for further information.
          </span>
          <span
            *ngIf="surveyDecode?.isCancelBlockedMsgVisible"
            id="spanCancelBlockedMsg"
            runat="server"
            visible="false"
            >The page you are looking for is no longer available.</span
          >
          <br />
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="isMobile; else WebErrFooter">
      <div
        *ngIf="surveyDecode?.IsErrorVisible || surveyDecode?.isCancelAccMsgVisible"
        class="footer-div survey-messages-footer"
      >
        <div
          *ngIf="!surveyDecode?.isPoweredByClient"
          class="btmNote onlyMessage"
          style="width: 100%"
        >
          <a href="{{ surveyDecode?.static_host }}" class="footrAnchor" target="_blank"></a>
          <span
            >Powered by
            <img alt="Powered by image" src="../survey/assets/ProductImages/SvgLogo.svg"
          /></span>
          <span [innerHTML]="surveyDecode?.PrivacyPolicy | headerFooterHtml"></span>
        </div>
      </div>
    </ng-container>
    <ng-template #WebErrFooter>
      <div
        *ngIf="surveyDecode?.IsErrorVisible || surveyDecode?.isCancelAccMsgVisible"
        class="sd-footer footer-div survey-messages-footer"
      >
        <div
          *ngIf="!surveyDecode?.isPoweredByClient"
          class="btmNote onlyMessage"
          style="width: 100%"
        >
          <span [innerHTML]="surveyDecode?.PrivacyPolicy | headerFooterHtml"></span>
        </div>
      </div>
    </ng-template>
  </div>
</div>
